<template>
    <div>
        <div class="header">
            <div class="ncmpLogo fl">
                <img src="../assets/img/logo.svg" alt />
            </div>
            <div class="headerNav fl">
                <ul class="ul">
                    <li class="navLi navLi_coverage">
                        <a class="navDa">产品系列</a>
                        <ul class="coverage">
                            <li class="textLeft"><a href="/npm">网络流量分析平台</a></li>
                            <li class="textLeft"><a href="/lingmou">灵眸智能运维平台</a></li>
                            <li class="textLeft"><a href="/firewall">防火墙策略可视化平台</a></li>
                            <li class="textLeft"><a href="/linglong">灵珑应用交付管理平台</a></li>
                        </ul>
                        <!-- <ul class="innerUl">
                <li class="innerLi" @click='$router.push({path:"index"})'><p class="sp_point"></p>  智能分析引擎</li>
                <li class="innerLi"><p class="sp_point"></p> 大数据引擎</li>
                <li class="innerLi"><p class="sp_point"></p> 安全分析引擎</li>
              </ul> -->
                    </li>
                    <!-- <li class="navLi">
              <router-link :to="{path:'/solution'}" tag="span">解决方案</router-link>
            </li> -->
                    <li class="navLi">
                        <router-link :to="{path:'/user'}" tag="span">用户案例</router-link>
                    </li>
                    <li class="navLi">
                        <router-link :to="{path:'/partner'}" tag="span">生态合作</router-link>
                    </li>
                    <li class="navLi">
                        <router-link :to="{path:'/support'}" tag="span">服务合作</router-link>
                    </li>
                    <li class="navLi navLi_coverage">
                        <router-link :to="{path:'/about'}" tag="span">关于我们</router-link>
                        <ul class="coverage">
                            <li @click="aboutus">公司简介</li>
                            <li @click="coverage">公司动态</li>
                        </ul>
                    </li>
                    <li class="navLi">
                        <router-link :to="{path:'/join'}" tag="span">加入我们</router-link>
                    </li>
                </ul>
            </div>
            <div class="trans fr">
                <div class="user"></div>
                <router-link :to="{path:'/school'}" tag="span">NC大学</router-link>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  data() {
    return {

    };
  },
  methods: {
      coverage(){
        this.$router.push('/coverage')
      },
      aboutus() {
          this.$router.push('/about')
      }
  }
};
</script>

<style lang='less' scoped>
.router-link-exact-active, .router-link-active{
  color: #0c9;
}
.header {
  user-select: none;
  width: 100%;
  height: 100px;
  position: relative;
  top: 0;
  background: #fff;
  color: black;
  z-index: 111;
  .ncmpLogo {
    margin-top: 31px;
    margin-left: 30px;
    width: 180px;
    height: 40px;
    margin-right: 90px;
    cursor: pointer;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .headerNav {
    height: 100%;
    .ul {
      height: 100%;
      .navLi {
        width: 100px;
        float: left;
        height: 100%;
        font-weight: bold;
        line-height: 100px;
        text-align: center;
        margin-right: 30px;
        position: relative;
        span {
          position: relative;
          font-size: 14px;
          cursor: pointer;
        }
        span:active::before{
          width: 50%;

        }
        span:active::after{
          width: 50%;
          transition: none;
        }
        a{
          color:#000;
        }
      }
      .navLi_coverage {
        .navDa{
            cursor: pointer;
        }
        .coverage{
          position: absolute;
          top: 70px;
          display: none;
          opacity: 0;
          width: 200px;
          height: 60px;
          font-size:14px;
          cursor: pointer;
          animation:moveup 0.5s;
          animation-fill-mode:forwards;
          animation-delay:.05s;
          background: #fff;
          left:-49px;
          top:100px;
          li{
            font-size: 14px;
            font-weight: 300;
            color: #000;
            background:#fff;
            line-height:60px;
            border-bottom:1px solid #d8d8d9;
            a:hover{
              color:#00cc99;
            }
          }
          li.textLeft{
            text-align: left;
            text-indent: 32px;
          }
          li:last-child{
            border:none;
          }
        }
        &:hover .coverage{
          display: block;
        }
        @keyframes moveup{ from{ transform: translateY(-0.2rem);} to{opacity: 1; transform: translateY(0);} }
      }
      .navLi span::before,
      .navLi span::after {
        content: "";
        position: absolute;
        pointer-events: none;
        bottom: -10px;
        left: 50%;
        height: 3px;
        width: 0;
        background-color: #00cc99;
        transition: all 0.2s linear;
      }
      .navLi:hover span::before {
        width: 50%;
        left: 0;
      }
      .navLi:hover span::after {
        width: 50%;
      }
      .navLi_current{
        color:#0c9;
      }
    }
  }
  .trans {
    display: flex;
    vertical-align: middle;
    margin-top: 40px;
    margin-right: 20px;
    align-items: center;
    cursor: pointer;
    font-size: 14px;
    .translate {
      cursor: pointer;
      font-size: 14px;
    }
    .user {
      width: 15px;
      height: 15px;
      margin-left: 20px;
      margin-right: 5px;
      background: url('../assets/img/index_user.svg') no-repeat;
    }
    span{
      font-weight: bold;
    }
  }
}

@media screen and (max-width: 1150px) {
  .headerNav {
    .navLi:nth-child(4) {
      display: none;
    }
    .navLi:nth-child(5) {
      display: none;
    }
    .navLi:nth-child(6) {
      display: none;
    }
  }
}

@media screen and (max-width: 769px) {
  .headerNav {
    display: none;
  }
}

@media screen and (max-width: 414px) {
  .trans {
    display: none !important;
  }
}
</style>